import React from 'react';
import MaskedInput, { conformToMask } from 'react-text-mask';
import mask from '../utils/mask';

export const BASIC_MASK =
  mask('(', [/\d/, 2], ')', ' ', [/\d/, 4], '-', [/\d/, 4]);

export const NINE_DIGITS_MASK =
  mask('(', [/\d/, 2], ')', ' ', [/\d/, 5], '-', [/\d/, 4]);

// 9 digits + 2 prefix
const phonemask = v => v.replace(/\D/g, '').length > 8 + 2 ? NINE_DIGITS_MASK : BASIC_MASK;

export function conform(input) {
  return conformToMask(input, phonemask(input)).conformedValue;
}

export default function PhoneInput(props) {
  const { inputRef, ...rest } = props;

  return <MaskedInput {...rest} ref={inputRef} mask={phonemask} />;
}
